import * as React from 'react';
import {FunctionComponent} from 'react';
import {endOfISOWeek, endOfMonth, endOfYear, format, startOfISOWeek, startOfMonth, startOfYear} from 'date-fns';
import {Link} from 'react-router-dom';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    className?: string;
}

export const QuickWorkoutLinks: FunctionComponent<OwnProps> = ({className}) => {
    return (
        <ul className={classNames('list-group', className)}>
            {[
                {
                    name: 'This week',
                    from: startOfISOWeek(new Date()),
                    till: endOfISOWeek(new Date()),
                },
                {
                    name: 'This month',
                    from: startOfMonth(new Date()),
                    till: endOfMonth(new Date()),
                },
                {
                    name: 'This year',
                    from: startOfYear(new Date()),
                    till: endOfYear(new Date()),
                },
            ].map((range) => (
                <li key={range.name} className="list-group-item">
                    <Link
                        to={`/workouts?dateRange.from=date.${format(
                            range.from,
                            'yyyy-MM-dd',
                        )}&dateRange.till=date.${format(range.till, 'yyyy-MM-dd')}`}
                    >
                        {range.name}
                    </Link>
                </li>
            ))}
        </ul>
    );
};
